const ReportingV2 = () => import(/* webpackChunkName: 'ReportingV2' */ '@/Reporting/ReportingV2');
const OverviewV1 = () =>
  import(/* webpackChunkName: 'ReportingV2' */ '@/Reporting/components/OverviewV1');
const EmailReportingV1 = () =>
  import(/* webpackChunkName: 'ReportingV2' */ '@/Reporting/components/EmailReportingV1');
const LeadsOverviewV1 = () =>
  import(/* webpackChunkName: 'ReportingV2' */ '@/Reporting/components/LeadsOverviewV1');
const LeadsTeamReportingV1 = () =>
  import(/* webpackChunkName: 'ReportingV2' */ '@/Reporting/components/LeadsTeamReportingV1');
const BulkActionsReportV2 = () =>
  import(/* webpackChunkName: 'ReportingV2' */ '@/Reporting/components/BulkActionsReportV2');

export default [
  {
    path: '/reporting',
    name: 'reporting',
    component: ReportingV2,
    meta: { auth: true },
  },
  {
    path: '/reporting/summary',
    name: 'reporting.overview',
    component: OverviewV1,
    meta: { auth: true },
  },
  {
    path: '/reporting/email-reporting',
    name: 'reporting.email',
    component: EmailReportingV1,
    meta: { auth: true },
  },
  {
    path: '/reporting/leads-overview',
    name: 'reporting.leads-overview',
    component: LeadsOverviewV1,
    meta: { auth: true },
  },
  {
    path: '/reporting/bulk-actions',
    name: 'reporting.bulk-actions',
    component: BulkActionsReportV2,
    meta: { auth: true },
  },
  {
    path: '/reporting/leads-team-reporting',
    name: 'reporting.leads-team',
    component: LeadsTeamReportingV1,
    meta: { auth: true },
  },
];
